/**
 * Journal / Blog Listing — tag filtering
 * Syncs top and bottom tabs + filters articles
 */
(function () {
  'use strict';

  function initJournalPage(root) {
    if (root.getAttribute('data-enable-filtering') === 'false') return;

    var tabs = root.querySelectorAll('.journal-page__tab');
    if (!tabs.length) return;

    var items = root.querySelectorAll(
      '.journal-page__card, .journal-page__featured'
    );

    var countNumberEl = root.querySelector('.journal-page__count-number');

    function setActiveTab(tag) {
      tabs.forEach(function (tab) {
        tab.classList.toggle(
          'journal-page__tab--active',
          tab.getAttribute('data-tag') === tag
        );
      });
    }

    function applyFilter(tag) {
      var visibleCount = 0;

      items.forEach(function (item) {
        var itemTags = (item.getAttribute('data-tags') || '').split(',');

        var matches =
          tag === 'all' ||
          itemTags.indexOf(tag) !== -1;

        if (matches) {
          item.removeAttribute('data-journal-hidden');
          visibleCount++;
        } else {
          item.setAttribute('data-journal-hidden', 'true');
        }
      });

      if (countNumberEl) {
        countNumberEl.textContent = visibleCount;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tag = tab.getAttribute('data-tag');

        // Sync ALL tabs (top + bottom)
        setActiveTab(tag);

        // Filter blogs
        applyFilter(tag);
      });
    });

    // Initial state
    setActiveTab('all');
    applyFilter('all');
  }

  function initAll() {
    document.querySelectorAll('.journal-page').forEach(initJournalPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.journal-page');

    if (section) {
      initJournalPage(section);
    }
  });
})();